/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CargomaticCard from 'components/v2/card';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import SendDOEmailModal from '../shipments/SendDOEmailModal';
import { Documents } from '../documents/Documents';
import AdminServerActionCreators from '../../../actions/AdminServerActionCreators';
import { orderDocTypes } from '../../../config/documents';
import { ShipmentDocumentList } from './ShipmentDocumentList';

export const OrderDocuments = ({ order, shipments }) => {
  const { t } = useTranslation();
  const [showEmailDeliveryOrderModal, setShowEmailDeliveryOrderModal] =
    useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleSendEmails = (emails) => {
    OrdersActionCreators.emailCustomDeliveryOrder(
      order._id,
      selectedDocumentId,
      emails,
    );
  };

  const handleShowEmailDeliveryOrderModal = (documentId) => {
    setShowEmailDeliveryOrderModal(true);
    setSelectedDocumentId(documentId);
  };

  const handleHideEmailDeliveryOrderModal = () => {
    setShowEmailDeliveryOrderModal(false);
    setSelectedDocumentId(null);
  };

  return (
    <CargomaticCard
      header={() => <h3 className="my-0">{t('ORDER_DOCUMENTS')}</h3>}
    >
      <Documents
        shipment={order}
        isOrder
        onEmail={handleShowEmailDeliveryOrderModal}
        onUpload={(order, _) => {
          AdminServerActionCreators.uploadOrderDocumentSuccess(order);
        }}
        onUploadFailed={(order, _, e) => {
          AdminServerActionCreators.uploadOrderDocumentFail({
            error: e?.message,
          });
        }}
        shipments={shipments}
        docTypes={orderDocTypes}
        pageNeighbours={0}
      />
      <h3 className="mb-0 mt-6">{t('ASSOCIATED_SHIPMENT_DOCS')}</h3>
      <hr className="my-4" />
      <ShipmentDocumentList shipments={shipments} />
      {showEmailDeliveryOrderModal && (
        <SendDOEmailModal
          show={showEmailDeliveryOrderModal}
          onSend={handleSendEmails}
          onHide={handleHideEmailDeliveryOrderModal}
        />
      )}
    </CargomaticCard>
  );
};

OrderDocuments.propTypes = {
  order: PropTypes.object,
};
